// src/pages/JobPostings.js
import React, { useState } from "react";

const JOBS = [
  {
    id: 1,
    title: "Probationary Officer (PO)",
    org: "State Bank of India (SBI)",
    vacancies: 2000,
    deadline: "2026-05-15",
    category: "Banking",
    link: "https://sbi.co.in/web/careers",
    status: "Active"
  },
  {
    id: 2,
    title: "Clerk Recruitment 2026",
    org: "Institute of Banking Personnel Selection (IBPS)",
    vacancies: 5400,
    deadline: "2026-05-20",
    category: "Banking",
    link: "https://ibps.in",
    status: "Active"
  },
  {
    id: 3,
    title: "Combined Graduate Level (CGL)",
    org: "Staff Selection Commission (SSC)",
    vacancies: 7500,
    deadline: "2026-06-10",
    category: "SSC",
    link: "https://ssc.nic.in",
    status: "Upcoming"
  },
  {
    id: 4,
    title: "Assistant Station Master",
    org: "Railway Recruitment Board (RRB)",
    vacancies: 1200,
    deadline: "2026-05-05",
    category: "Railways",
    link: "https://indianrailways.gov.in",
    status: "Active"
  },
  {
    id: 5,
    title: "Grade B Officers",
    org: "Reserve Bank of India (RBI)",
    vacancies: 250,
    deadline: "2026-06-01",
    category: "Banking",
    link: "https://rbi.org.in",
    status: "Upcoming"
  },
  {
    id: 6,
    title: "Multi-Tasking Staff (MTS)",
    org: "Staff Selection Commission (SSC)",
    vacancies: 3000,
    deadline: "2026-05-12",
    category: "SSC",
    link: "https://ssc.nic.in",
    status: "Active"
  }
];

const CATEGORIES = ["All", "Banking", "SSC", "Railways", "Others"];

export default function JobPostings() {
  const [filter, setFilter] = useState("All");
  const [search, setSearch] = useState("");

  const filteredJobs = JOBS.filter(job => {
    const matchesFilter = filter === "All" || job.category === filter;
    const matchesSearch = job.title.toLowerCase().includes(search.toLowerCase()) || 
                          job.org.toLowerCase().includes(search.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div>
      <h1 className="page-title">Government Job Alerts</h1>
      <p className="page-sub">Latest vacancies and application links for banking and government exams</p>

      {/* Filters & Search */}
      <div className="card" style={{ marginBottom: 20, padding: 15 }}>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <input 
            type="text" 
            placeholder="Search jobs or organizations..." 
            className="form-input" 
            style={{ flex: 1, minWidth: 200 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="filter-row" style={{ marginBottom: 0 }}>
            {CATEGORIES.map(c => (
              <button 
                key={c} 
                className={`filter-btn ${filter === c ? "active" : ""}`}
                onClick={() => setFilter(c)}
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Job Grid */}
      <div className="stats-row" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))" }}>
        {filteredJobs.length === 0 ? (
          <div className="card" style={{ gridColumn: "1 / -1", textAlign: "center", padding: 40 }}>
            <p style={{ color: "var(--text-muted)" }}>No job postings found matching your criteria.</p>
          </div>
        ) : (
          filteredJobs.map(job => (
            <div key={job.id} className="card" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                <span className={`tag ${job.status === "Active" ? "tag-easy" : "tag-medium"}`}>
                  {job.status}
                </span>
                <span style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)" }}>{job.category}</span>
              </div>

              <div>
                <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>{job.title}</h3>
                <p style={{ fontSize: 13, color: "var(--text-secondary)", fontWeight: 500 }}>{job.org}</p>
              </div>

              <div style={{ background: "var(--bg)", padding: "10px 12px", borderRadius: 8, fontSize: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                  <span style={{ color: "var(--text-muted)" }}>Vacancies:</span>
                  <span style={{ fontWeight: 600 }}>{job.vacancies}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ color: "var(--text-muted)" }}>Deadline:</span>
                  <span style={{ fontWeight: 600, color: "var(--red)" }}>{new Date(job.deadline).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                </div>
              </div>

              <a 
                href={job.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-dark btn-block"
                style={{ marginTop: "auto" }}
              >
                Apply Now ↗
              </a>
            </div>
          ))
        )}
      </div>

      <div style={{ marginTop: 24, padding: 15, background: "var(--blue-bg)", borderRadius: 12, color: "var(--blue-dark)", fontSize: 12 }}>
        ℹ️ <strong>Note:</strong> We recommend verifying details on the official organization websites before applying.
      </div>
    </div>
  );
}
